import { addNarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { useWidgetPillsAndFilters } from 'hooks/useWidgetPillsAndFilters';

import { useQueryGetScheduleQualityScore } from 'api/queries/getScheduleQualityScore.query';

import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';

export type UseScheduleQualityScoreProvider = ReturnType<typeof useScheduleQualityScoreProvider>;

interface Props {
    componentKey: string;
    widgetId?: string;
    latestVersionId?: number | undefined;
    compareVersionId?: number | undefined;
    globalFilterData: any;
    localFilters: any;
    contractId: number | null | undefined;
}

export const useScheduleQualityScoreProvider = ({
    widgetId,
    latestVersionId,
    localFilters,
    globalFilterData,
    compareVersionId,
    componentKey,
    contractId,
}: Props) => {
    const { isGenerativeAi } = usePinboardWidgetWrapperContext();
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? localFilters : { ...globalFilterData };

    const { filters, pills } = useWidgetPillsAndFilters({ widgetId, latestVersionId, source });

    const getScheduleQualityScorePayload = {
        compareVersionId,
        latestVersionId,
        contractId,
        filter: {
            filters,
        },
        ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId),
    };

    const getScheduleQualityScore = useQueryGetScheduleQualityScore(getScheduleQualityScorePayload);

    return {
        ui: {
            state: {
                activityCodes: source?.activityCodes,
                milestoneFragnet: source?.milestoneFragnet,
                tags: source?.tags,
                wbs: source?.wbs,
            },
            pills: pills,
        },
        api: {
            getScheduleQualityScore: {
                instance: getScheduleQualityScore,
                payload: getScheduleQualityScorePayload,
            },
        },
    };
};
